/*
  Altra event tracking — the one bridge from theme code to GA4.

  GA4 is not loaded by the theme. It arrives via the Google & YouTube channel
  app running as a SANDBOXED web pixel in Settings > Customer events, so gtag()
  and dataLayer do not exist in this page context and calling them is a no-op.
  The only supported route is Shopify.analytics.publish(), which a Custom Pixel
  picks up with analytics.subscribe(<name>, cb) and forwards to GA4.

  Classic script on purpose, not a module: sections load it with plain defer and
  read window.altraTrack, including from <script type="module"> blocks.
*/
window.altraTrack = function (name, params) {
  try {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(name, params || {});
    }
  } catch (e) {
    /* analytics must never break the page */
  }
};

/*
  Entry points (search promo, product banner, homepage band) mark their CTAs with
  data-altra-entry="<source>". One delegated listener covers all of them, so a new
  entry point needs the attribute and nothing else.
*/
document.addEventListener('click', function (e) {
  var a = e.target && e.target.closest ? e.target.closest('[data-altra-entry]') : null;
  if (!a) return;
  window.altraTrack('designer_entry_click', { source: a.getAttribute('data-altra-entry') });
});
